import { render, staticRenderFns } from "./FooterLocale.vue?vue&type=template&id=4062b4ed&scoped=true&"
import script from "./FooterLocale.vue?vue&type=script&lang=js&"
export * from "./FooterLocale.vue?vue&type=script&lang=js&"
import style0 from "./FooterLocale.vue?vue&type=style&index=0&id=4062b4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062b4ed",
  null
  
)

export default component.exports